import { AxiosError, AxiosResponse } from 'axios';

export const Authorizer = {
	authData: undefined as AppUser | undefined,
	authURL: undefined as string | undefined,

	init(authURL: string) {
		this.authURL = authURL;
	},

	setAuthData(data: AppUser) {
		this.authData = data;
	},

	getAuthData() {
		return this.authData;
	},

	redirect() {
		const redirectUri = encodeURIComponent(window.location.href);
		window.location.replace(`${this.authURL}/?redirect=${redirectUri}`);
	},

	async validateToken(tokenPromise: () => Promise<AxiosResponse>) {
		try {
			const response = await tokenPromise();
			this.setAuthData(response?.data);
			return response?.data;
		} catch (err) {
			const castErr = err as AxiosError<Record<string, any>>;
			if (castErr.response && castErr.response.status === 401) {
				this.redirect();
			}
			return castErr;
		}
	},
};
